/* global window: true */
import React from 'react';
import _ from 'lodash';
import moment from 'moment';

import './OverviewModal.scss';
import SlideList from '../SlideList/SlideList';
import InlineEdit from '../InlineEdit/InlineEdit';
import reducerStore from '../../reducers/reducerStore';
import axios from '../../lib/AxiosInstance';

class OverviewModal extends React.Component {
    constructor(props) {
        super(props);

        moment.locale('sv');
        
        this.createNewSlide = this.createNewSlide.bind(this);
        this.removeSlide = this.removeSlide.bind(this);
        this.moveToTv = this.moveToTv.bind(this);
        this.reorderDone = this.reorderDone.bind(this);
        this.openSettings = this.openSettings.bind(this);
    }

    createNewSlide() {
        reducerStore.dispatch({ type: 'CREATE NEW SLIDE', tvIndex: this.props.tvIndex });
    }

    removeSlide(event, removeId) {
        axios.delete(`/api/salestv/${removeId}`).then(() => {
            reducerStore.dispatch({ type: 'REMOVE SLIDE', id: removeId });
        }).catch(error => console.log(error));

        if (removeId === this.props.currentSlideId) {
            reducerStore.dispatch({ type: 'PREVIOUS SLIDE' });
        }

        event.stopPropagation();
    }

    moveToTv(slideId, newTvId, index) {
        const { slides } = this.props;

        const tv = _.find(slides, ['id', slideId]);

        tv.tvIndex = newTvId;

        const slidesPerTv = _.groupBy(slides, slide => (_.get(slide, 'tvIndex', 0)));

        const newPositions = slides.map((slide) => {
            let position = _.findIndex(slidesPerTv[slide.tvIndex || 0], ['id', slide.id]);
            if (slide.tvIndex === newTvId && position >= index) {
                position += 1;
            }
            return Object.assign({}, slide, { position });
        });

        const newTv = _.find(newPositions, ['id', slideId]);

        newTv.position = index;
        newTv.inactive = 0;

        const needToUpdate = newPositions.filter((slide, theIndex) =>
            slides[theIndex].position !== slide.position ||
            (slides[theIndex].tvIndex || 0) !== slide.tvIndex);

        // The one that was just moved needs to be updated
        needToUpdate.push(newTv);

        if (needToUpdate.length === 0) return;

        // Only send PUTs for the ones that need to be updated.
        needToUpdate.forEach((slide) => {
            // Update the reducer state with the new positions.
            reducerStore.dispatch({ type: 'SLIDE SAVED', slide });

            axios.put(`/api/salestv/${slide.id}`, slide).catch(error => console.log(error));
        });
    }

    reorderDone(reorderedArray) {
        const { slides } = this.props;

        const needToUpdate = reorderedArray.filter((slide, index) =>
            slides[index].id !== slide.id ||
            slides[index].position !== slide.position ||
            slides[index].tvIndex !== slide.tvIndex);

        if (needToUpdate.length === 0) return;

        // Only send PUTs for the ones that need to be updated.
        needToUpdate.forEach((slide) => {
            // Update the reducer state with the new positions.
            reducerStore.dispatch({ type: 'SLIDE SAVED', slide });

            axios.put(`/api/salestv/${slide.id}`, slide).catch(error => console.log(error));
        });
    }

    openSettings() {
        reducerStore.dispatch({ type: 'TOOGLE SETTINGS MODAL' });
    }

    openChannelsModal() {
        reducerStore.dispatch({ type: 'CHANGE CHANNEL', tvIndex: this.props.tvIndex, showChannelsModal: true });
    }

    render() {
        const { 
            clientId,
            companyProfile,
            currency,
            currentSlideId,
            editSlide,
            goToSlide,
            licenses, 
            notificationThreshold,
            overviewTabIndex,
            panels,
            hideModal,
            slideInterval,
            slides,
            slidesData,
            toggleOverview,
            tvIndex,
            tvNames,
            updateTvNames,
            useCompanyProfile } = this.props;

        let overviewClasses = ['overview-modal'];
        if (!hideModal) {
            overviewClasses.push('show-modal');
        }

        return (
            <div className="container">
                <div className={overviewClasses.join(' ')}>
                    <div className="menu">
                        <ul>
                            <li onClick={() => this.openSettings()}>
                                <i className="fa fa-sliders" aria-hidden="true"></i>
                                <span>Generella inställningar</span>
                            </li>
                            <li onClick={() => this.openChannelsModal()}>
                                <i className="fa fa-th-large" aria-hidden="true"></i>
                                <span>Alla kanaler</span>
                            </li>
                        </ul>
                    </div>
                    <div className='slide-heading'>
                        <InlineEdit
                            text={tvNames[tvIndex] || 'Kanal ' + tvIndex}
                            updateState={value => updateTvNames(tvIndex, value)}
                        />
                        <i className="fa fa-pencil" aria-hidden="true"></i>
                    </div>
                    <div className="slide-settings">            
                        <SlideList
                            currentSlideId={this.props.currentSlideId}
                            currency={currency}
                            slides={slides}
                            slidesData={this.props.slidesData}
                            goToSlide={goToSlide}
                            reorderDone={this.reorderDone}
                            moveToTv={this.moveToTv}
                            editSlide={editSlide}
                            removeSlide={this.removeSlide}
                            createNewSlide={this.createNewSlide}
                            tvIndex={this.props.tvIndex}
                            companyProfile={companyProfile}
                        />
                    </div>
                </div>  
            </div>
        );
    }
}

OverviewModal.propTypes = {
    clientId: React.PropTypes.number,
    companyProfile: React.PropTypes.object,
    currency: React.PropTypes.string,
    currentSlideId: React.PropTypes.string,
    editSlide: React.PropTypes.func,
    goToSlide: React.PropTypes.func,
    licenses: React.PropTypes.number,
    notificationThreshold: React.PropTypes.number,
    hideModal: React.PropTypes.bool,
    slideInterval: React.PropTypes.number,
    slides: React.PropTypes.array,
    slidesData: React.PropTypes.object,
    tvIndex: React.PropTypes.number,
    tvNames: React.PropTypes.array,
    updateTvNames: React.PropTypes.func,
    useCompanyProfile: React.PropTypes.bool,
}

export default OverviewModal;



/** WEBPACK FOOTER **
 ** ./client/components/OverviewModal/OverviewModal.jsx
 **/